
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-series-plug-in-solar-battery-v2/support",
      function () {
        return require("private-next-pages/stream-series-plug-in-solar-battery-v2/support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-series-plug-in-solar-battery-v2/support"])
      });
    }
  